var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23.5H1.5C0.947715 23.5 0.5 23.0523 0.5 22.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H22.5C23.0523 0.5 23.5 0.947715 23.5 1.5V22.5C23.5 23.0523 23.0523 23.5 22.5 23.5H16.5V14.5H19.059C19.3126 14.502 19.5276 14.3137 19.559 14.062L19.934 11.062C19.9519 10.919 19.9072 10.7753 19.8114 10.6676C19.7156 10.56 19.5781 10.4989 19.434 10.5H16.5V9.185C16.5011 8.25447 17.2555 7.50055 18.186 7.5H20C20.2761 7.5 20.5 7.27614 20.5 7V4C20.5 3.72386 20.2761 3.5 20 3.5H18.186C15.0475 3.50331 12.5039 6.04647 12.5 9.185V10.5H10C9.72386 10.5 9.5 10.7239 9.5 11V14C9.5 14.2761 9.72386 14.5 10 14.5H12.5V23.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.831d4e9b6654de4cfaf7825b9a08f3af.svg";
export { ForwardRef as ReactComponent };